import axios, { AxiosInstance } from 'axios';
import { convertDates } from '../utils/convert-dates';

const client: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'X-TenantId': null,
    Authorization: null,
  },
  withCredentials: true,
});

client.interceptors.response.use((response) => {
  convertDates(response.data);
  return response;
});

export default client;
